<template>
  <div class="popup-container">
    <div @click.stop="toggleMenu" class="trigger">
      <slot name="trigger"/>
    </div>
    <div class="outside-listener" @click.stop="onClickOutside" :style="{ display: popupOpen ? 'flex' : 'none'}"/>
    <div class="popup-content" :style="{ display: popupOpen ? 'flex' : 'none'}">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupMenu",
  data() {
     return {
       popupOpen: false
     }
  },
  methods: {
    toggleMenu() {
      this.popupOpen = !this.popupOpen
    },
    onClickOutside() {
      this.popupOpen = false
    }
  }
}
</script>

<style scoped>
.trigger{
  display: inline;
  padding: 0px 5px;
}
.popup-container {
  display: inline;
}
.popup-content {
  position: absolute;
  top: 100%;
  left: 0;
  contain: content;
  z-index: 2;
  background-color: #181826;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 5px 5px 5px black;
  pointer-events: all;
}
.outside-listener {
  position: fixed;
  width: 150vw;
  height: 100vh;
  top: 0;
  left: 0;
}
.popup-content >>> a {
  position: relative;
}
</style>